import _ from 'lodash';

// group_by_name_no_group açıkken bile, adı shop_kolaj'da kolaj_name olarak geçmeyen
// dosyalar regexe göre gruplanır. Adı geçen dosya daha önce tek tek import edilmiş
// demektir; olduğu gibi bırakılır ki eski kayıtlar bozulmasın.
// group_by_name_keep_imported kapalıyken davranış eskisi gibi — diğer mağazalar etkilenmez.
// Not: shop-server/lib/helper.js içindeki isNoGroupFile ile aynı mantık, ikisi birlikte değişmeli.
export function isNoGroupFile(file, { group_by_name_no_group, group_by_name_keep_imported, imported_names }) {
	if (!group_by_name_no_group) return false;
	if (!group_by_name_keep_imported) return true;
	if (!imported_names) return false;
	let name = _.isString(file) ? file : _.get(file, 'name');
	return imported_names.has(name);
}
